export interface Promotion {
    shop_id: number;
    allow_apply_concurrent_flg: number;
    auto_apply_flg: number;
    branch_ids: any;
    branches_are_applicable: any;
    collaborator_percent: any;
    collaborator_type: any;
    condition_detail: number;
    condition_flag: number;
    end_date: string;
    ended_at: string | null;
    external_app_identifies: any;
    id: number;
    is_time: number;
    is_weekdays: number;
    max_use: number;
    max_use_per_customer: number;
    minimum_quantity: number;
    online_flg: number;
    promotion_code: string | null;
    promotion_desc: string | null;
    promotion_extra_condition: any;
    promotion_group_id: number | null;
    promotion_image: string | null;
    promotion_max_price: number;
    promotion_name: string;
    promotion_time_slots: any;
    promotion_type: number;
    promotion_value: number;
    start_date: string | null;
    start_time: string | null;
    started_at: string | null;
    status: number;
    target_channel: any;
    target_detailtype: any;
    target_type: number;
    to_time: any;
    topping_flg: number;
    weekdays: string | null;
    promotion_subtype: number;
    public_info?: PromotionPublicInfo;
    can_apply?: number | boolean;
    missing_amount?: number | boolean;
    promotion_apply?: any;
    promotion_detail?: any;
    promotion_subtype2: number;
}
export interface PromotionPublicInfo {
    title: string;
    description: string;
    tier_id: number;
    is_auto_apply: boolean;
    is_show_for_select: boolean;
    suggest_message: string;
}
export interface PromotionGroup {
    promotion_type: number;
    list_promotion: Promotion[];
    list_promotion_order?: Promotion[]; // hoá đơn
    list_promotion_order_product?: Promotion[]; // hoá đơn món
    list_promotion_gift?: Promotion[]; // tặng món
    list_promotion_delivery?: Promotion[]; // vận chuyển
    is_load?: boolean;
}

export enum PROMOTION_STATUS {
    // 0: pending; 1: running; 2: end
    PENDING = 0,
    RUNNING = 1,
    END = 2
}
